// automatic transpilation and polyfills w/ Babel - https://babeljs.io/docs/en/index.html
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// dependencies
import 'jquery';
import 'bootstrap';
import AOS from 'simple-aos';
import './vendor/slick.min.js';
import scroller from './utils/scroller';
scroller.scroller();

// manual polyfills
import './polyfills/polyfills';

// dataLayer scripts
import './datalayer/index';

import './components/site-header/mega-nav';
import './components/site-header/utility-nav';
import './components/site-header/global-nav';
import './components/site-header/search-box';
import './components/spotlight/splotlight-slider';
import './components/global-components/mobile-dropdown';
import './components/banners/banner-2-images';
import './components/brands-listings/brands-listings';
import './components/notification/notification';
import './components/stats/set-of-3';
import './components/article-card-slider/article-card-slider';
import './components/article-card-slider/article-card-slider-mobile';
import './components/banners/hero';
import './components/content-card/content-card';
import './components/snippets/video-snippet';
import './components/banners/media-slider';
import './components/management/management-details-sidebar-links';
import './components/corporate-contact/corporate-contact-dropdown';
import './components/news-listings/news-listings';
import './components/search-listings/search-listings';
import './components/pdf-listings/pdf-listings';
import './components/location-results/location-results';
import './components/forms/contact-us';
import './components/50-50-components/50-50-item';
import './components/tabs/tabs';
import './components/downloads/downloads';
import './components/timeline/timeline.js';

if (process.env.NODE_ENV === 'development') {
    require('@api/mock/mock-server').default();
}

AOS.init({
    offset: 80,
    duration: 1000,
});